/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { StarHalfIcon16Light } from './StarHalfIcon16Light';
import { StarHalfIcon16Regular } from './StarHalfIcon16Regular';
import { StarHalfIcon16Solid } from './StarHalfIcon16Solid';
import { StarHalfIcon20Light } from './StarHalfIcon20Light';
import { StarHalfIcon20Regular } from './StarHalfIcon20Regular';
import { StarHalfIcon20Solid } from './StarHalfIcon20Solid';
import { StarHalfIcon24Regular } from './StarHalfIcon24Regular';
import { StarHalfIcon24Solid } from './StarHalfIcon24Solid';
import { StarHalfIcon32Regular } from './StarHalfIcon32Regular';
import { StarHalfIcon64Regular } from './StarHalfIcon64Regular';
var sizes = {
    16: {
        light: StarHalfIcon16Light,
        regular: StarHalfIcon16Regular,
        solid: StarHalfIcon16Solid,
    },
    20: {
        light: StarHalfIcon20Light,
        regular: StarHalfIcon20Regular,
        solid: StarHalfIcon20Solid,
    },
    24: {
        regular: StarHalfIcon24Regular,
        solid: StarHalfIcon24Solid,
    },
    32: {
        regular: StarHalfIcon32Regular,
    },
    64: {
        regular: StarHalfIcon64Regular,
    },
};
export var StarHalfIcon = forwardRef('StarHalfIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
